import { Identifiable, ProjectReport } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  report: Identifiable<ProjectReport>,
  { resources }: Filter,
) {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find((resource) => resource.name === report.author)
  );
}

export { isFilteredByResources };
